import getters from './getters';
import actions from './actions';
import mutations from './mutations';
import { CALCULATE_TYPE } from '@/common/constants/ConstCode';

export const state = {
  backgroundPreViewImage: '',
  form: {
    preViewImage: '',
    profileRawFile: null,
    invitationFile: null,
    invitationText: '',
    profileFileInfo: null,
    smileNo: '',
    userNo: '',
    category: '',
    hasSecond: false,
    type: '',
    firstName: '',
    secondName: '',
    hostName: '',
    eventDate: '',
    eventDateTime: '',
    firstRelation: [
      { relation: '부', name: '' },
      { relation: '모', name: '' }
    ],
    secondRelation: [
      { relation: '부', name: '' },
      { relation: '모', name: '' }
    ],
    address: '',
    buildingName: '',
    latitude: '',
    longitude: '',
    parkingNote: '',
    transportNote: '',
    canUseEmo: true,
    hasInvitation: true,
    calculateType: CALCULATE_TYPE.CASH.key,
    onlineStartDate: '',
    onlineEndDate: '',
    firstAccounts: [
      {
        accountHolder: '',
        bank: '선택(은행)',
        accountNumber: ''
      }
    ],
    secondAccounts: [
      {
        accountHolder: '',
        bank: '선택(은행)',
        accountNumber: ''
      }
    ],
    galleryRawFiles: [], // 갤러리에서 새로 등록할 이미지들
    galleryFileList: [], // 기존 저장된 이미지들
    gallery: [],

    alertList: [],
    message: '',
    bgImageNo: ''
  },

  detail: {},
  nextId: null,
  pagingCondition: {
    page: 1,
    limit: 20,
    smileNo: '',
    pageInfo: {}
  },
  list: [],
  background: [],
  commentList: [],
  placeList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
